import { useIntl } from 'react-intl';

import DrawerPage from 'components/layout/drawer-page';
import { MntCard } from 'pages/loyalty/loyalty-partners/mnt';
import { WalmartOffer } from 'pages/loyalty/loyalty-partners/walmart/walmart-offer';

export default function Partnerships() {
  const { formatMessage } = useIntl();
  const headerText = formatMessage({ id: 'partnerOffers' });

  return (
    <DrawerPage headerText={headerText}>
      <WalmartOffer />
      <MntCard />
    </DrawerPage>
  );
}
